import React from 'react'
import {
  ListItem,
  IconWspAlert,
  IconErase,
  Avatar,
  IconSignCheck,
  DropDownNew,
  IconOptions,
  DropDownItem
} from '@Knowledge-OTP/znk-ui-components'
// import LazyAvatar from '../../../../../../common/LazyAvatar'
import useCheckInStudentModal from '../Modal/CheckInStudent/useCheckInStudentModal'
import useDismissNotification from '../Modal/DismissNotification/useDismissNotification'
import useTranslation from '../../../../../../i18n/useTranslation'
import './index.css'

export const buildPlanListItemOptions = ({
  reason = 'homework',
  translate = (text) => text,
  onSendWspAlert = () => {},
  onDismissNotification = () => {}
}) => {
  return [].concat(
    reason === 'pending' ? [] : [
      {
        component: (
          <DropDownItem
            onClick={onSendWspAlert}
            className='text-info align-items-center'
          >
            <IconWspAlert size={16} /> {translate('dashboard.issueCheckIn.listItem.sendWspAlert')}
          </DropDownItem>
        )
      }
    ]
  ).concat(
    [
      {
        component: (
          <DropDownItem
            onClick={onDismissNotification}
            className='text-error danger-option align-items-center'
          >
            <IconErase size={16} /> {translate('dashboard.issueCheckIn.listItem.dismissNotification')}
          </DropDownItem>
        )
      }
    ]
  )
}

const PlanListItem = (props) => {
  const { open: openCheckInStudent, close } = useCheckInStudentModal()
  const { open: openDismissNotification, close: closeDismissNotification } = useDismissNotification()
  const { translate } = useTranslation()

  const {
    className = '',
    text = <>Daniel Admin</>,
    reason = 'homework',
    description = '',
    refetch = () => {},
    studentId, studentName, studentData = {},
    serviceReason = '',
    onAvatarClick = () => {},
    isSelected = false,
    isMultiSelectMode = false,
    ...otherProps
  } = props

  const options = buildPlanListItemOptions({
    reason,
    translate,
    onSendWspAlert: () => {
      openCheckInStudent(() => {
        close()
        refetch()
      }, studentData, reason, description, text)
    },
    onDismissNotification: () => {
      openDismissNotification(() => {
        closeDismissNotification()
        refetch()
      }, studentData, reason, serviceReason)
    }
  })

  return (
    <ListItem
      // showBottomLine
      hasHover={false}
      className={`px-4 py-3 hover-no-border issue-checkin-list-item ${isSelected ? 'issue-checkin-list-item-selected' : ''} ${className}`}
      classNameLeft='w-60'
      Left={
        <div className='d-flex flex-row align-items-center'>
          <div
            className='d-flex flex-row align-items-center cursor-pointer'
            onClick={onAvatarClick}
          >
            {isSelected
              ? (
                <div className='issue-checkin-avatar-check mr-2'>
                  <IconSignCheck size={13} className='text-white'  />
                </div>
              )
              : (
                <Avatar
                  name={studentName}
                  avatar={studentData?.avatar}
                  className='mr-2'
                  size='avatar-medium'
                />
              )}
          </div>
          <div className='d-flex flex-column w-100'>
            <span title={studentName} className='text-info'>{studentName}</span>
            <span title={text} className='text-gray h45 text-truncate'>
              {text}
            </span>
            {/* <span className={`text-gray h45`}>
                            {studentId}
                        </span> */}
          </div>
        </div>
      }
      Right={
        !isMultiSelectMode
          ? (
            <DropDownNew
              direction='bottomLeft'
              options={options}
            >
              <div className='hover-icon'>
                <IconOptions className='rotate-90' />
              </div>
            </DropDownNew>
          )
          : null
      }
      {...otherProps}
    />
  )
}

export default PlanListItem
